import pdfIcon from "@assets/article/pdfIcon.avif";
import pdfIconNew from "@assets/article/pdfIconNew.svg";
import Link from "@elements/Typography/Link";
import { Attachment } from "@typings/Opensearch";
import { twMerge } from "tailwind-merge";

type AttachmentCardProps = {
  attachment: Attachment;
  className?: string;
  newDesign?: boolean;
};

export default function AttachmentCard({
  attachment,
  className,
  newDesign,
}: AttachmentCardProps) {
  return (
    <div data-testid="attachment-pdf" className={twMerge("flex", className)}>
      <Link
        destination={attachment.content["attachmentLink-caas"]}
        relativePath={false}
        type="application/pdf"
        className={
          newDesign
            ? "flex gap-[5px] items-center text-xxs font-secondary font-medium leading-[150%] text-blue-100 underline"
            : "flex gap-1 items-center text-md text-blue-300 hover:underline hover:text-blue-700"
        }
      >
        {!newDesign && (
          <img src={pdfIcon} alt="pdf-icon" width={16} height={16} />
        )}
        {newDesign && (
          <img src={pdfIconNew} alt="pdf-icon" width={40} height={40} />
        )}
        {attachment.content.title}
      </Link>
    </div>
  );
}
